import { atom } from 'recoil'
import { IEquipment } from '../equipment.types.ts'

interface IEquipmentState {
  items: IEquipment[]
  loaded: boolean
}

const equipmentAtom = atom<IEquipmentState>({
  key: 'equipment',
  default: {
    items: [],
    loaded: false,
  },
})

export default equipmentAtom
